import styled from "styled-components";
import { ButtonSettings, ArrowScroll, Icon } from "../../../services/visualLibraryService";
import { shadowStyled } from "../../../styles/shared-styles";
import { i18n } from "../../../services/i18nService";

export const LayoutStyled = styled.section`
  width: 100%;
  top: 0;
  bottom: 0;
  //position: absolute;
 // will-change: transform;
  //transform: ${props => `translateY(${props.position}px)`};
  transition: transform 0.2s linear;
  &::after {
    opacity: 0;
  }
  /* Showing shadows when the layout has content */
  &.hasContent {
    &::before {
      pointer-events: none;
      ${props =>
        shadowStyled(
          "top",
          // "-0.5vw",
          `${props.theme.baseLayoutPaddingBs * 3}%`,
          props.theme.backgroundRGB,
          0,
          props.theme.zIndex.base
        )};
    }
  }
  /* Showing shadow inside before when the layout is scrolling */
  &.isLayoutScrolling {
    &::before {
      opacity: 1;
    }
    /* FIXME: To remove with the new layout + carousel implementation */
    article,
    article + div {
      transform: ${props => `translateY(-${props.position}px)`};
    }
  }

  &.noHero {
    margin-top: 10.2rem;
  }
  
  article:nth-child(2n) {
    // transform: translateY(-100px);
    transform: ${props => `translateY(-${props.position}px)`};
    -webkit-transform:${props => `translateY(-${props.position}px)`};
    -ms-transform: ${props => `translateY(-${props.position}px)`};
   }
  & .Styled__ImageContainerStyled-t5q7es-1 {
    position : relative;
    width:100%;
   
  }
  article.focused .selected svg{
    fill: ${props => props.theme.color.primary} !important;
  }
  & .selected span{
    opacity:1 !important;
  }

  & .channelCarosal .slide div div:first-child img{
    margin-top: -0.5px;
     visibility:visible;
  }
  & .channelCarosal .slide.selected  div div:first-child img{
      visibility:visible;
  }

`;

/* TODO: review this shadow in the new Header + Layout + carousel refactorization */
/* prettier-ignore */
export const ShadowLayoutStyled = styled.div`
  ${props =>
    shadowStyled("bottom", "-0.5vw", `${props.theme.baseLayoutPaddingBs * 3}%`, '#27324E;' || props.theme.backgroundRGB, 1, props.theme.zIndex.base)};
  transition: opacity 0.3s ease-in-out;
  /* Removing shadow inside after when the layout ends */
  ${LayoutStyled}.isLayoutEnd ~ & {
    opacity: 0;
  }
`;

export const ButtonStyled = styled(ButtonSettings)`
  margin: 0 auto ${props => props.theme.spacing.xsmall};
  transform: translateY(0.5rem);
  margin-${props => (props.theme.locale.dir !== i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: 4.167rem;
`;

export const ArrowScrollStyled = styled(ArrowScroll)`
  position: absolute;
  top: -${props => props.theme.spacing.large};
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.2s linear;
  will-change: opacity;
  opacity: ${props => (props.isVisible ? 1 : 0)};
`;

export const LayoutEmptyStyled = styled.div`
  text-align: center;
  padding-top: ${props => props.theme.baseLayoutPaddingBs}%;
`;

export const IconStyled = styled(Icon)`
  fill: ${props => props.theme.color.secondary};
  margin-bottom: 0.8rem;
  width: 2vw;
  height: 3vh;
`;
export const LayoutUpArrow = styled.div`
  width: 3.25rem;
  height: 3.25rem;
  position: absolute;
  z-index: 30;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
`;

export const LayoutDownArrow = styled.div`
  width: 3.25rem;
  height: 3.25rem;
  z-index: 30;
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
`;

export const UpArrow = styled.svg.attrs(props => ({
  viewBox: props.theme.components.icon.viewBox
}))`
  width: 10.5em;
  height: 4.5em;
  ${props => (props.theme.locale.dir !== "rtl" ? "margin-left:45%;" : "margin-right:45%;")}
  margin-top:15%;
  &:hover {
    margin-top: 14%;
    height: 5em;
    transition: all 0.2s;
  }
`;

export const FillBtnUpArrow = styled.path.attrs(props => ({
  d: props.theme.components.icon.list["arrowUp"].path
}))`
  fill: ${props => props.theme.color.primary};
  fill-opacity: 1;
  z-index: 15;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const DownArrow = styled.svg.attrs(props => ({
  viewBox: props.theme.components.icon.viewBox
}))`
  width: 10.5em;
  height: 4.5em;
  ${props => (props.theme.locale.dir !== "rtl" ? "margin-left:45%;" : "margin-right:45%;")}
  margin-top:10%;
  &:hover {
    margin-top: 11%;
    height: 5em;
    transition: all 0.2s;
  }
`;

export const FillBtnDownArrow = styled.path.attrs(props => ({
  d: props.theme.components.icon.list["arrowDown"].path
}))`
  fill: ${props => props.theme.color.primary};
  fill-opacity: 1;
  z-index: 15;
  stroke-width: 0px;
  fill-rule: nonzero;
`;
